import { ValidationTextFieldWithIcon } from "@cede/ds";
import { formatNumberAsString, unformatNumberAsString } from "@cede/utils";
import { Box, Tooltip, tooltipClasses, Typography, useTheme } from "@mui/material";

type LimitPriceProps = {
  priceSymbol: string;
  limitPrice: string;
  price: string;
  setLimitPrice: (price: string) => void;
};

export function LimitPrice({ priceSymbol, limitPrice, price, setLimitPrice }: LimitPriceProps) {
  const theme = useTheme();
  const unformattedLimitPrice = unformatNumberAsString(limitPrice);
  const unfornattedPrice = unformatNumberAsString(price);
  const percentageDifference =
    price !== "0"
      ? ((Number(unformattedLimitPrice || 0) - Number(unfornattedPrice || 0)) / Number(unfornattedPrice || 0)) * 100
      : 0;

  return (
    <Box display="flex" gap={theme.spacing()} marginTop={theme.spacing(1.5)}>
      <Tooltip
        title={
          <Typography variant="caption" color={theme.palette.text.primary} fontWeight={"bold"} fontSize={"0.8rem"}>
            {percentageDifference > 0 ? "+" : ""} {percentageDifference.toFixed(2)}%
          </Typography>
        }
        arrow
        placement="top"
        PopperProps={{
          disablePortal: true,
          sx: {
            [`& .${tooltipClasses.tooltip}`]: {
              marginTop: "6px!important",
            },
          },
        }}
      >
        <Box flex={1} width={"100%"}>
          <ValidationTextFieldWithIcon
            label="Price"
            value={limitPrice}
            handleChange={(e) => {
              setLimitPrice(formatNumberAsString(e.target.value));
            }}
            validate={() => ({ color: "success" })}
            sx={{
              flex: 1,
              width: "100%",
            }}
            icon={<Typography variant="body1">{priceSymbol}</Typography>}
          />
        </Box>
      </Tooltip>

      <ValidationTextFieldWithIcon
        label="Actual price"
        value={price}
        validate={() => ({ color: "success" })}
        sx={{
          flex: 1,
          width: "auto",
        }}
        disabled
        icon={<Typography variant="body1">{priceSymbol}</Typography>}
      />
    </Box>
  );
}
